import { Section, Chapter, Reveal } from "./Section";
import LeadForm from "./LeadForm";
import { Leaf, Pill, Salad, Sun } from "lucide-react";

const TOPICS = [
  [Leaf, "Herbs & Natural Remedies"],
  [Pill, "Supplements & Nutrition"],
  [Salad, "Lifestyle Practices"],
  [Sun, "Whole-Person Well-Being"],
];

export default function Wellness() {
  return (
    <Section id="wellness" testid="wellness-section">
      <div className="grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-6">
          <span data-testid="wellness-badge" className="inline-flex items-center gap-2.5 mb-6 border border-cyan-400/40 bg-cyan-400/10 text-cyan-200 px-4 py-2 rounded-full text-sm font-semibold font-mono uppercase tracking-widest">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 animate-pulse-dot" />
            Upcoming Launch
          </span>
          <Chapter number="05" label="Holistic Wellness" testid="wellness-chapter"
            title={<>Healthy Body. Healthy Mind.<br /><span className="text-cyan-gold">Healthy Life.</span></>}
            sub="Education surrounding natural and naturopathic approaches to wellness — led by Prophet Terrell Turner, certified herbalist and student holistic naturopathic practitioner." />
          <Reveal delay={0.2} className="mt-8">
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal max-w-lg">
              Spiritual development and responsible stewardship of physical health work together as part of a balanced life.
              Take charge of your health — naturally.
            </p>
            <p className="mt-6 text-sm text-slate-400 max-w-lg">
              Educational wellness information is intended to complement, not replace, appropriate medical care, diagnosis, or treatment.
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-10">
            <div className="relative group max-w-lg">
              <div aria-hidden className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-emerald-500/20 to-cyan-500/15 blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="relative overflow-hidden rounded-[1.75rem] border border-emerald-400/25 shadow-[0_0_50px_rgba(52,211,153,0.12)] transition-transform duration-700 group-hover:scale-[1.02]">
                <img src="/assets/wellness-herbs.jpeg" alt="Holistic Herbs and Living" data-testid="wellness-herbs-image"
                  className="w-full object-cover" />
                <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-[#06070B]/50 via-transparent to-transparent" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <div className="grid sm:grid-cols-2 gap-4">
            {TOPICS.map(([Icon, label], i) => (
              <Reveal key={label} delay={0.06 * i}>
                <div data-testid={`wellness-topic-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group card-hover glass rounded-2xl p-6 hover:!border-cyan-400/40 hover:shadow-[0_24px_60px_-24px_rgba(34,211,238,0.3)]">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-cyan-500/25 to-emerald-500/25 border border-white/10 text-cyan-300 group-hover:from-cyan-400 group-hover:to-emerald-400 group-hover:text-[#06070B] transition-all duration-300">
                    <Icon size={18} />
                  </span>
                  <p className="mt-4 font-display text-xl font-bold text-slate-100">{label}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-6 glow-frame">
            <div className="rounded-[1.7rem] bg-[#0B0E16] p-7">
              <p className="mb-6 font-mono text-sm font-semibold uppercase tracking-[0.25em] text-cyan-gold">Join the Wellness Community</p>
              <LeadForm type="wellness" idPrefix="wellness" submitLabel="Join the Wellness Community" />
            </div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
